import { render } from "./restart-button.vue?vue&type=template&id=75a19db9&scoped=true"
import script from "./restart-button.vue?vue&type=script&lang=js"
export * from "./restart-button.vue?vue&type=script&lang=js"

import "./restart-button.vue?vue&type=style&index=0&id=75a19db9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a19db9"]])

export default __exports__